import * as React from 'react';
import { AvatarColourPicker } from './AvatarColourPicker';
import { AvatarColour } from '../../../models';
import './style.css';

export interface AvatarEditorProps {
  colour: string;
  firstName?: string;
  lastName?: string;
  onUpdate: (colour: AvatarColour) => void;
}

export interface AvatarEditorState {
  editing?: boolean;
}

export class AvatarEditor extends React.Component<
  AvatarEditorProps,
  AvatarEditorState
> {
  constructor(props: AvatarEditorProps) {
    super(props);

    this.state = {};
  }

  render() {
    const { colour, firstName, lastName, onUpdate } = this.props;
    const { editing } = this.state;

    return (
      <div className="avatar-editor">
        <div
          className="avatar-preview"
          style={{
            background: colour
          }}
        >
          {firstName && firstName[0]} {lastName && lastName[0]}
        </div>
        <div
          className="avatar-edit-button edge-of-play-link"
          role="button"
          onClick={() => this.setState({ editing: !this.state.editing })}
        >
          {editing ? 'Cancel' : 'Change Avatar Colour'}
        </div>
        {editing ? (
          <div className="avatar-colour-picker-wrapper">
            <AvatarColourPicker
              colour={colour}
              onSave={(newColour: AvatarColour) => {
                this.setState({ editing: false });
                onUpdate(newColour);
              }}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default AvatarEditor;



// WEBPACK FOOTER //
// ./src/app/components/UserProfile/AvatarEditor/index.tsx